export const getConfigValue = (key, fallback = '') => {
  const value = process.env[key];

  if (typeof value === 'string' && value.trim()) {
    return value.trim();
  }

  return fallback;
};
